import React from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import hero from '../assets/images/hero/arandaplus.jpg'
import arandaintro from '../assets/images/arandaplus/mas.gif'
import arandacard from '../assets/images/arandaplus/arandacard4.png'
import icon from '../assets/images/branding/icon6.png'
import { LuBadgeCheck } from 'react-icons/lu'

export default function Arandapluswelcome() {
    return (
        <div id='LoyaltyProgram'>
            <Navbar />

            <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${hero})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-gradient-overlay"></div>
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            <div className="title-heading text-center">
                                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">Programa de Beneficios Aranda+</h5>
                            </div>
                        </div>
                    </div>

                    <div className="position-middle-bottom">
                        <nav aria-label="breadcrumb" className="d-block">
                            <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Aranda +</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>

            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>
            <section className="section bg-inverted pt-3">
                <div className="container">
                    <div className="row justify-content-center my-5">
                        <div className="col-12 col-sm-8 text-center">
                            <img src={arandaintro} alt="Aranda +" className='w-100 rounded mx-auto' />
                        </div>
                    </div>
                    <div className="row justify-content-center">

                        <div className="col-lg-7 col-12 mt-4 mt-md-0 p-4 pt-4 pt-md-0">
                            <div className="section-title text-center">
                                <h2 className="text-primary text-uppercase">Le damos la bienvenida</h2>
                                <h3 className="text-primary text-uppercase">a nuestro programa de beneficios Aranda+</h3>
                                <blockquote>
                                    Ahora puede acceder a descuentos exclusivos en salud y bienestar. Debió haber recibido un correo electrónico con su contraseña. Si no lo ha recibido, por favor revise su bandeja de spam.
                                </blockquote>
                                <p className="para-desc text-muted">
                                    En Hospital Aranda de la Parra, reafirmamos nuestro compromiso de estar contigo en cada etapa de tu vida. Con nuestro programa de beneficios, obtienes descuentos especiales en farmacia, laboratorio, imagenología y más.
                                    <br /> <br />
                                    <strong>Sus beneficios</strong> <br />
                                </p>
                                <div className='text-start my-4'>
                                    <p><LuBadgeCheck /> <strong>15%</strong> de descuento en Farmacia</p>
                                    <p><LuBadgeCheck /> <strong>20%</strong> en Imagenología (excepto PET)</p>
                                    <p><LuBadgeCheck /> <strong>10%</strong> en Laboratorio</p>
                                    <p><LuBadgeCheck /> <strong>Tarifa especial</strong> en hospedaje en el Hotel Yvette</p>
                                    <p><LuBadgeCheck /> <strong>Tarifa especial</strong> en consulta de urgencias (médico general)</p>
                                    <p><LuBadgeCheck /> <strong>Promociones, descuentos y eventos exclusivos</strong> durante todo el año.</p>

                                </div>
                                <div className="small mt-5 text-muted text-start">
                                    <strong>Términos y condiciones</strong>
                                    <p>
                                        Válido en ambas sucursales al mostrar su número de membresía e identificación. Aplica para ventas externas y no hospitalarias o urgencias. No acumulable con otras promociones.
                                    </p>
                                    <p>
                                        Urgencias: Aplica para titular e hijos presentando identificación. No incluye estudios clínicos ni valoración por especialistas.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section bg-pink pt-3 pb-0">
                <div className="container">
                    <div className="row justify-content-center my-0 py-0">
                        <div className="col-12 text-center my-4">
                            <img src={icon} className="img-fluid slidericon mx-auto" alt="" />
                        </div>
                        <div className="col-12 col-sm-8 text-center mb-0">
                            <img src={arandacard} alt="Aranda +" className='img-fluid w-75' />
                        </div>
                    </div>
                </div>
            </section>

            <Footer />

            <ScrollToTop />
        </div>
    )
}
